import React from "react";
import styled from "styled-components";
import { rhythm } from "../utils/typography";
import presets from "../utils/presets"

// wrapper
const CrossHairsWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  position:absolute;
  top:0;
  left:0;
  right:0;
  max-width:100%;
`

const CrossHairsBox = styled.div`
  height: calc(100%/3);
  width: calc(100%/3);
  display: flex;
  justify-content: center;
  align-items: center;
`

const Hline = styled.div`
  width:${rhythm(1)};
  height:1px;
  background-color: ${presets.olddark};
  position:absolute;
`

const Vline = styled.div`
  height:${rhythm(1)};
  width:1px;
  background-color: ${presets.olddark};
  position:absolute;
`
export default () => {
  return (
      <CrossHairsWrapper>
        <CrossHairsBox><Hline /><Vline /></CrossHairsBox>
        <CrossHairsBox><Hline /><Vline /></CrossHairsBox>
        <CrossHairsBox><Hline /><Vline /></CrossHairsBox>
        <CrossHairsBox><Hline /><Vline /></CrossHairsBox>
        <CrossHairsBox><Hline /><Vline /></CrossHairsBox>
        <CrossHairsBox><Hline /><Vline /></CrossHairsBox>
        <CrossHairsBox><Hline /><Vline /></CrossHairsBox>
        <CrossHairsBox><Hline /><Vline /></CrossHairsBox>
        <CrossHairsBox><Hline /><Vline /></CrossHairsBox>
      </CrossHairsWrapper>
  );
}



// WEBPACK FOOTER //
// ./src/com/Crosshairs.js